export default __webpack_public_path__ + "static/media/american eagle.df52a16a.svg";